import { TablePagination, TablePaginationProps } from '@mui/material';
import WithTestId from 'components/WithTestId/WithTestId';

const PaginationWithTestId = WithTestId<TablePaginationProps>(TablePagination);

export default PaginationWithTestId;
